import { render } from "./EntityPartiesEditor.vue?vue&type=template&id=54cfb76a&scoped=true"
import script from "./EntityPartiesEditor.vue?vue&type=script&lang=js"
export * from "./EntityPartiesEditor.vue?vue&type=script&lang=js"

import "./EntityPartiesEditor.vue?vue&type=style&index=0&id=54cfb76a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cfb76a"]])

export default __exports__